export const SystemPermissions = {
    1: 'Read',
    2: 'Edit',
    3: 'FullControl'
}
